<template>
  <div>
    <!-- Corpo -->
    <div class="bg-white rounded-lg shadow-md p-4 mb-4">
      <div class="flex justify-center">
        <img :src="`/images/icons/reception-digitale/loghi-aziendali/`+$page.props.customer?.slug+`/loghi.png`" class="h-20">
      </div>
    </div>
    <div class="bg-white rounded-lg pulse-red-border p-4 mb-4">
      <h1 class="text-center text-xl font-bold text-red-500">Inserire il destinatario del pacco:</h1>
    </div>
    <form @submit.prevent="submitForm()">
      <!-- Hidden fields for backend -->
      <input type="hidden" v-model="form.name" />
      <input type="hidden" v-model="form.company" />
      
      <div class="px-6 pb-0">
        <div class="grid grid-cols-2 bg-white rounded-md shadow-lg px-4 py-2">
          <div class="p-4">
            <div class="mb-4 pb-2">
              <label class="font-bold mb-3 block text-red-500">Se siete in possesso del nominativo del destinatario selezionarlo qui
              </label>
              <v-select
                :searchable="false"
                placeholder="A chi devi consegnare?"
                label="name"
                v-model="form.contact"
                :options="contacts"
                :clearable="false"
                :class="{ 'pulse-red-border': shouldHighlightContact }"
              ></v-select>
              <!--<select v-model="form.contact" :class="{ 'pulse-red-border': shouldHighlightContact }" class="p93__input">
                <option value="" disabled selected>A chi devi consegnare?</option>
                <option v-for="contact in contacts" :key="contact.id" :value="contact">{{ contact.name }}</option>
              </select>-->
              <div v-if="form.errors.contact_id" class="text-red-500 text-sm pt-2">{{ form.errors.contact_id }}</div>
            </div>
          </div>
          <div class="p-4">
            <!-- Sezione selezione azienda -->
            <div class="mb-4">
              <label class="font-bold mb-3 block text-red-500">Se siete in possesso solo del nome dell'azienda destinataria selezionarla qui:</label>
              <div class="grid grid-cols-2 gap-4">
                <div
                  v-for="(companyName, companySlug) in companies"
                  :key="companySlug"
                  @click="selectCompany(companySlug)"
                  :class="[
                    'bg-white rounded-lg p-4 cursor-pointer shadow-md border border-gray-200 flex flex-col items-center',
                    { 'ring-2 ring-blue-500 bg-blue-50': selectedCompany === companySlug },
                    { 'hover:shadow-lg': selectedCompany !== companySlug },
                    { 'pulse-red-border': shouldHighlightCompany }
                  ]"
                >
                  <img :src="`/images/icons/reception-digitale/aziende-corrieri/${companySlug}.png`" class="h-16 mb-2" :alt="companyName">
                  <p class="text-sm text-center text-gray-700">{{ companyName }}</p>
                </div>
              </div>
              
              <div v-if="form.errors.company_destination" class="text-red-500 text-sm pt-2">{{ form.errors.company_destination }}</div>
            </div>
          </div>
          <div class="flex justify-center pb-2 col-span-2">
            <Link :href="route('modules.home', { slug: 'reception-digitale' })"
              class="bg-white hover:bg-gray-100 text-gray-700 px-4 py-2 rounded-md flex items-center border pr-3 mr-4">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
              </svg>
              Torna indietro
            </Link>
            <button type="submit"
              class="bg-blue-500 hover:bg-blue-600 disabled:bg-blue-300 text-white px-8 py-2 rounded-lg flex items-center text-xl font-semibold disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
              :disabled="(!selectedCompany && !form.contact) || isSubmitting">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
              Procedi
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { Link, useForm, router } from '@inertiajs/vue3';
import LayoutNoHeader from '@/Layouts/LayoutNoHeader.vue';
import axios from 'axios';

export default {
  props: ['errors', 'contacts', 'selectedContact', 'firmaType', 'companies'],
  layout: LayoutNoHeader,
  components: {
    Link
  },
  data() {
    return {
      form: useForm({
        company: null,
        contact_id: '',
        contact: '',
        delivery_type: null, // For the new courier delivery system
        company_destination: null // Selected company destination
      }),
      selectedCompany: null, // Track selected company
      dateFormat: 'yyyy-MM-dd',
      searchContactBy: null,
      foundContacts: [],
      isSubmitting: false,
    };
  },
  mounted() {
    this.form.delivery_type = this.firmaType;
  },
  methods: {
    async submitForm() {
      this.isSubmitting = true;
      try {
        // Prepare form data
        this.form.contact_id = this.form.contact?.id ?? null;
        
        // Use axios to submit the form
        const response = await axios.post(route('modules.rd-nuova-consegna'), {
          contact_id: this.form.contact_id,
          company_destination: this.form.company_destination,
          delivery_type: this.form.delivery_type,
        });

        this.isSubmitting = false;
        
        // Get the courier delivery ID from response
        const courierDeliveryId = response.data.courierDelivery;
        
        // Redirect based on delivery type with the ID as parameter
        if (this.firmaType === 'con-firma') {
          router.visit(route('modules.rd-corriere-consegna-con-firma', { courierDelivery: courierDeliveryId }));
          return;
        }
        if (this.firmaType === 'senza-firma') {
          router.visit(route('modules.rd-corriere-consegna-senza-firma', { courierDelivery: courierDeliveryId }));
          return;
        }
        
        // Default redirect to home
        router.visit(route('modules.home', 'reception-digitale'));
        
      } catch (error) {
        this.isSubmitting = false;
        console.error('Errore nella registrazione consegna:', error);
        
        // Handle validation errors
        if (error.response && error.response.data && error.response.data.errors) {
          // Set form errors
          Object.keys(error.response.data.errors).forEach(key => {
            this.form.setError(key, error.response.data.errors[key][0]);
          });
        }
      }
    },
    selectCompany(companyKey) {
      this.selectedCompany = companyKey;
      this.form.company_destination = companyKey;
      if (companyKey) {
        this.form.contact = null;
        this.form.contact_id = 'nobody';
      }
    },
    resetForm() {
      if (this.firmaType === 'con-firma') {
        router.get(route('modules.rd-corriere-con-firma'));
      } else {
        router.get(route('modules.rd-corriere-senza-firma'));
      }
    }
  },
  watch: {
    visitor(value) {
      this.form.name = value?.name;
      this.form.company = value?.company;
    }
  },
  computed: {
    shouldHighlightContact() {
      return !this.form.contact && !this.selectedCompany;
    },
    shouldHighlightCompany() {
      return !this.form.contact && !this.selectedCompany;
    }
  }
};
</script>